export const editOrg = [{
    key: 'organisation_name',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'organisation_name',
        label: 'Name',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

},
{
    key: 'country__id',
    type: 'select',
    value: '',
    valid: false,
    elementConfig: {
        name: 'country_name',
        label: 'Country',
        options: [],
    },
    validation: {
        required: true,
        message: "is required"
    }
}
]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/OrgDetails/formData.js